import { ButtonProps, TextButton, Tooltip } from '@shape-ds/components';
import { StepCircle } from 'components/Cases/StepCircle';
import React from 'react';
import './CollapseTitle.scss';

export interface TooltipType {
  title?: string;
  followCursor?: boolean;
}

export interface CollapseActionButton {
  icon?: React.ReactNode;
  text: string;
  visible?: boolean;
  custom?: React.ElementType;
  onClick?: <T extends React.MouseEvent<HTMLButtonElement>>(e: T) => void;
}

export type CollapseTitleProps = {
  title: string | React.ReactNode;
  tooltip?: TooltipType;
  button?: CollapseActionButton;
  indicator?: string;
  disabled?: boolean;
  name?: string;
  customElement?: React.ReactNode;
};

export const CollapseTitle = ({
  button,
  title,
  tooltip,
  indicator,
  disabled,
  name,
  customElement,
}: CollapseTitleProps) => {
  if (!title) return null;

  const buttonProps: Partial<ButtonProps> = button || {};
  const ButtonWrapper = tooltip ? Tooltip : 'div';
  const Button = button?.custom || TextButton;

  const isButtonVisible = button?.visible ?? !!button?.text;

  return (
    <div className={`collapse-title-container ${name || ''}`} data-testid="title-container">
      <div className="collapse-title-content">
        {indicator && <StepCircle step={indicator} />}
        <span data-testid="title">{title}</span>
      </div>

      <div className="collapse-action">
        {customElement ||
          (isButtonVisible && (
            <ButtonWrapper
              title={tooltip?.title}
              followCursor={false}
              {...tooltip}
              data-testid="collapse-tooltip"
              {...(!tooltip && { 'data-testid': 'collapse-button-wrapper' })}
            >
              {button?.onClick ? (
                <Button
                  className="collapse-action-button"
                  startIcon={button?.icon}
                  onClick={button?.onClick}
                  disabled={disabled}
                  data-testid="action-button"
                  {...buttonProps}
                >
                  {button.text}
                </Button>
              ) : (
                <div
                  className={`collapse-action-text ${
                    disabled ? 'collapse-action-text-disabled' : 'collapse-action-text-enabled'
                  }`}
                  data-testid="action-text"
                >
                  {button?.text}
                </div>
              )}
            </ButtonWrapper>
          ))}
      </div>
    </div>
  );
};
